import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import {
  ActionSheetController,
  AlertController,
  LoadingController,
  MenuController,
  ModalController,
  PopoverController,
} from '@ionic/angular';
import { LeadsUpdateStatusPage } from 'src/app/leads-update-status/leads-update-status.page';
import { NotificationPage } from 'src/app/notification/notification.page';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util/util.service';
import { KonfirmasiHapusComponent } from 'src/app/shared/state/konfirmasi-hapus/konfirmasi-hapus.component';
import { environment } from 'src/environments/environment';
import { DelegasiModalSubmitComponent } from '../delegasi-modal-submit/delegasi-modal-submit.component';
// import { ComFilterLeadsComponent } from '../com-filter-leads/com-filter-leads.component';
// import { LeadsUpdateStatusPage } from '../leads-update-status/leads-update-status.page';
// import { UtilService } from '../services/util/util.service';
// import { environment } from 'src/environments/environment';
// import { NotificationPage } from '../notification/notification.page';
// import { ApiService } from '../services/api.service';
// import { KonfirmasiHapusComponent } from '../shared/state/konfirmasi-hapus/konfirmasi-hapus.component';

@Component({
  selector: 'app-delegasi-list',
  templateUrl: './delegasi-list.component.html',
  styleUrls: ['./delegasi-list.component.scss'],
})
export class DelegasiListComponent implements OnInit {
  manjang: boolean = false;
  baseUrl: any = '';
  provision_key: any = '';
  client_id: any = '';
  client_secret: any = '';
  grant_type: any = '';
  authUrl: any = '';

  chartt: any;
  accor: any = '';
  accorr: any = '';

  isIndeterminate: boolean;
  masterCheck: boolean;
  checkBoxList: any;

  page: any = 1;

  fractionSize;
  ionicForm: FormGroup;
  isSubmitted = false;
  nn: any = '';
  form: any = '';

  user: any;
  token: any;
  hasil: any;
  load: boolean = false;

  leadn: any = {};
  lnores: any;
  aa: any;

  opsi: boolean = false;
  totalCekData: any;
  pageInfo: any = {};
  pageNation: any;

  viewType: any;

  filter: any = '';
  filterr: any = '';

  resAr: any;
  add: any = {};

  users: any;
  parent: any = {};
  children: any = {};
  action: any;

  act1: any;
  act2: any;
  act3: any;
  act4: any;

  info: string = 'pengajuan';
  pageCbi: any = 1;
  leadnCbi: any = {};
  lnoresCbi: any;
  pageInfoCbi: any = {};
  pageNationCbi: any;
  cbiRes: any = {};
  delegasiKelompokResponse: any = {};
  dataDelegasiKelompok: object = {};
  pageDelegasiKelompok: number = 1;
  pindahKelompokResponse: any = {};
  dataPindahKelompok: object = {};
  pagePindahKelompok: number = 1;
  pageInfoPindahKelompok: any = {};
  cbR: any;
  retryCheckCbiCount: number = 0;
  dataCbi: any = {};
  btnDisabled: boolean = true;

  btnDisabledKelompok: boolean = true;
  selct: any = 'Kelompok';

  pageOrang: any = 1;
  leadnOrang: any = {};
  lnoresOrang: any;
  pageInfoOrang: any = {};
  pageInfoDelegasiKelompok: any = {};
  pageNationOrang: any;
  orangRes: any = {};
  orangR: any;
  retryCheckOrangCount: number = 0;
  dataOrang: any = {};
  btnDisabledOrang: boolean = true;

  constructor(
    public popoverController: PopoverController,
    public modalController: ModalController,
    public menuCtrl: MenuController,
    public route: Router,
    public http: HttpClient,
    public loadingctrl: LoadingController,
    public alertctrl: AlertController,
    public util: UtilService,
    public activatedRoute: ActivatedRoute,
    public formBuilder: FormBuilder,
    public actionSheetController: ActionSheetController,
    public api: ApiService
  ) {
    this.baseUrl = environment.restURL.baseUrl;
    this.provision_key = environment.restURL.provision_key;
    this.client_id = environment.restURL.client_id;
    this.client_secret = environment.restURL.client_secret;
    this.grant_type = environment.restURL.grant_type;
    this.authUrl = environment.restURL.authUrl;

    this.activatedRoute.queryParams.subscribe((params) => {
      if (params && params.refresh) {
        this.ionViewWillEnter();
      }
    });
  }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.token = localStorage.getItem('usertoken') || '';
    this.ionicForm = this.formBuilder.group({
      name: [''],
    });
    this.users = this.api.getUserMenu();
    this.addx();
  }

  ionViewWillEnter() {
    this.page = 1;
    this.res();

    this.pageCbi = 1;
    this.kelompok();

    this.pageOrang = 1;
    this.perorangan();

    this.pagePindahKelompok = 1;
    this.getPindahKelompok();

    this.pageDelegasiKelompok = 1;
    this.getDelegasiKelompok();


  }

  pilih(p) {
    console.log(p);
    if (this.selct == '') {
      this.selct = p;
    } else if (this.selct == p) {
      // this.selct = '';
    } else {
      this.selct = p;
    }
    console.log('selct', this.selct);
  }

  async assign(p: any, name: any) {
    const modal = await this.modalController.create({
      component: DelegasiModalSubmitComponent,
      cssClass: 'wd-assignXX',
      componentProps: {
        id: JSON.stringify([p]),
        nama: name,
        status: 'survey',
      },
    });
    modal.onDidDismiss().then((data) => {
      // this.page = 1;
      if (data.role === 'confirm') {
        this.page = 1;
        this.btnDisabled = true;
        this.masterCheck = false;
        this.isIndeterminate = false;
        this.res();
      }else{
        this.btnDisabled = true;
        this.masterCheck = false;
        this.isIndeterminate = false;
      }
    });
    return await modal.present();
  }

  async assignBulk() {
    const modal = await this.modalController.create({
      component: DelegasiModalSubmitComponent,
      cssClass: 'wd-assignXX',
      componentProps: {
        id: JSON.stringify(this.resAr.id),
        listNama: JSON.stringify(this.aa),
        status: 'survey',
      },
    });
    modal.onDidDismiss().then((data) => {
      if (data.role == 'confirm') {
        this.page = 1;
        this.btnDisabled = true;
        this.masterCheck = false;
        this.isIndeterminate = false;
        this.res();
      }else{
        this.btnDisabled = true;
        this.masterCheck = false;
        this.isIndeterminate = false;
      }
    });
    return await modal.present();
  }

  async assignKelompok(p: any, name: any) {
    const modal = await this.modalController.create({
      component: DelegasiModalSubmitComponent,
      cssClass: 'wd-assignXX',
      componentProps: {
        id: JSON.stringify([p]),
        nama: name,
        status: 'kelompok',
      },
    });
    modal.onDidDismiss().then((data) => {
      // this.page = 1;
      if (data.role === 'confirm') {
        this.pageCbi = 1;
        this.btnDisabled = true;
        this.masterCheck = false;
        this.isIndeterminate = false;
        this.kelompok();
      }else{
        this.btnDisabled = true;
        this.masterCheck = false;
        this.isIndeterminate = false;
      }
    });
    return await modal.present();
  }

  async assignBulkKelompok() {
    const modal = await this.modalController.create({
      component: DelegasiModalSubmitComponent,
      cssClass: 'wd-assignXX',
      componentProps: {
        id: JSON.stringify(this.resAr.id),
        listNama: JSON.stringify(this.aa),
        status: 'kelompok',
      },
    });
    modal.onDidDismiss().then((data) => {
      if (data.role == 'confirm') {
        this.page = 1;
        this.btnDisabled = true;
        this.masterCheck = false;
        this.isIndeterminate = false;
        this.kelompok();
      }else{
        this.btnDisabled = true;
        this.masterCheck = false;
        this.isIndeterminate = false;
      }
    });
    return await modal.present();
  }

  async assignOrang(p: any, name: any) {
    const modal = await this.modalController.create({
      component: DelegasiModalSubmitComponent,
      cssClass: 'wd-assignXX',
      componentProps: {
        id: JSON.stringify([p]),
        nama: name,
        status: 'orang',
      },
    });
    modal.onDidDismiss().then((data) => {
      // this.page = 1;
      if (data.role === 'confirm') {
        this.pageOrang = 1;
        this.btnDisabledOrang = true;
        this.masterCheck = false;
        this.isIndeterminate = false;
        this.perorangan();
      }else{
        this.btnDisabledOrang = true;
        this.masterCheck = false;
        this.isIndeterminate = false;
      }
    });
    return await modal.present();
  }

  async assignBulkOrang() {
    const modal = await this.modalController.create({
      component: DelegasiModalSubmitComponent,
      cssClass: 'wd-assignXX',
      componentProps: {
        id: JSON.stringify(this.resAr.id),
        listNama: JSON.stringify(this.aa),
        status: 'orang',
      },
    });
    modal.onDidDismiss().then((data) => {
      if (data.role == 'confirm') {
        this.pageOrang = 1;
        this.btnDisabledOrang = true;
        this.masterCheck = false;
        this.isIndeterminate = false;
        this.perorangan();
      }else{
        this.btnDisabledOrang = true;
        this.masterCheck = false;
        this.isIndeterminate = false;
      }
    });
    return await modal.present();
  }

  async assignPindahKelompok(p: string, group: string, name: any) {
    const modal = await this.modalController.create({
      component: DelegasiModalSubmitComponent,
      cssClass: 'wd-assignXX',
      componentProps: {
        id: JSON.stringify(p),
        kelompok: group,
        nama: name,
        status: 'pindahKelompok',
      },
    });
    modal.onDidDismiss().then((data) => {
      if (data.role === 'confirm') {
        this.pagePindahKelompok = 1;
        this.btnDisabledKelompok = true;
        this.isIndeterminate = false;
        this.getPindahKelompok();
      }else{
        this.btnDisabledKelompok = true;
        this.isIndeterminate = false;
      }
    });
    return await modal.present();
  }

  async assignDelegasiKelompok(p: string, group: string, name: any) {
    const modal = await this.modalController.create({
      component: DelegasiModalSubmitComponent,
      cssClass: 'wd-assignXX',
      componentProps: {
        id: JSON.stringify(p),
        kelompok: group,
        nama: name,
        status: 'delegasiKelompok',
      },
    });
    modal.onDidDismiss().then((data) => {
      if (data.role === 'confirm') {
        this.pageDelegasiKelompok = 1;
        this.btnDisabledKelompok = true;
        this.isIndeterminate = false;
        this.getDelegasiKelompok();
      }else{
        this.btnDisabledKelompok = true;
        this.isIndeterminate = false;
      }
    });
    return await modal.present();
  }

  perorangan() {
    this.load = true;
    let a = {
      product_name: this.nn,
    };
    let b = {
      payment_type_id: '',
    };
    let form = JSON.stringify({
      q: a,
      and: b,
      page: this.pageOrang,
      // limit:6
    });
    this.api
      .post('backoffice/delegasi/collection/perorangan-list', form)
      .subscribe(
        (data) => {
          this.leadnOrang = data;
          console.log('leadnCbi', this.leadnOrang);
          if (this.leadnOrang.error == 0) {
            this.load = false;
            this.lnoresOrang = this.leadnOrang.data.rows;
            this.pageInfoOrang = this.leadnOrang.data;
            console.log('pageNation', this.pageNationOrang);
            console.log('lnores', this.lnoresCbi);
            console.log('pageInfo', this.pageInfoOrang.page_info);
          } else {
            this.load = false;
            this.util.showToast(this.leadnOrang.message, 'success', 'bottom');
          }
        },
        (error) => {
          this.load = false;
          console.log('error', error);
          if (error.error.error == 'invalid_token' || error.status == 401) {
            this.fungsilogout();
          } else if (
            error.error.error_description == 'The access token is missing'
          ) {
            this.util.showToast(
              error.error.error_description,
              'danger',
              'bottom'
            );
            this.fungsilogout();
          } else if (error.error.error_message) {
            this.util.showToast(error.error.error_message, 'danger', 'bottom');
          } else if (!error.error.error_message) {
            this.util.showToast(error.error.message, 'danger', 'bottom');
          } else {
            this.util.showToast(error.error.message, 'danger', 'bottom');
          }
        }
      );
  }

  firstPageOrang() {
    this.pageOrang = 1;
    // this.kelompok();
    this.perorangan();
  }

  prevPageOrang() {
    this.pageOrang = this.pageOrang -= 1;
    // this.kelompok();
    this.perorangan();
  }

  nextPageOrang() {
    this.pageOrang = this.pageOrang + 1;
    // this.kelompok();
    this.perorangan();
  }

  lastPageOrang() {
    this.pageOrang = this.pageInfoOrang.total_pages;
    // this.kelompok();
    this.perorangan();
  }

  firstPageCbs() {
    this.pageCbi = 1;
    this.kelompok();
  }

  prevPageCbs() {
    this.pageCbi = this.pageCbi -= 1;
    this.kelompok();
  }

  nextPageCbs() {
    this.pageCbi = this.pageCbi + 1;
    this.kelompok();
  }

  lastPageCbs() {
    this.pageCbi = this.pageInfoCbi.total_pages;
    this.kelompok();
  }

  firstPagePindah() {
    this.pagePindahKelompok = 1;
    this.getPindahKelompok();
  }

  prevPagePindah() {
    this.pagePindahKelompok = this.pagePindahKelompok -= 1;
    this.getPindahKelompok();
  }

  nextPagePindah() {
    this.pagePindahKelompok = this.pagePindahKelompok + 1;
    this.getPindahKelompok();
  }

  lastPagePindah() {
    this.pagePindahKelompok = this.pageInfoPindahKelompok.total_pages;
    this.getPindahKelompok();
  }


  firstPageDelegasi() {
    this.pageDelegasiKelompok = 1;
    this.getDelegasiKelompok();
  }

  prevPageDelegasi() {
    this.pageDelegasiKelompok = this.pageDelegasiKelompok -= 1;
    this.getDelegasiKelompok();
  }

  nextPageDelegasi() {
    this.pageDelegasiKelompok = this.pageDelegasiKelompok + 1;
    this.getDelegasiKelompok();
  }

  lastPageDelegasi() {
    this.pageDelegasiKelompok = this.pageInfoDelegasiKelompok.total_pages;
    this.getDelegasiKelompok();
  }

  kelompok() {
    this.load = true;
    let a = {
      product_name: this.nn,
    };
    let b = {
      payment_type_id: '',
    };
    let form = JSON.stringify({
      q: a,
      and: b,
      page: this.pageCbi,
      // limit:6
    });
    this.api
      .post('backoffice/delegasi/collection/kelompok-list', form)
      .subscribe(
        (data) => {
          this.leadnCbi = data;
          console.log('leadnCbi', this.leadnCbi);
          if (this.leadnCbi.error == 0) {
            this.load = false;
            this.lnoresCbi = this.leadnCbi.data.rows;
            this.pageInfoCbi = this.leadnCbi.data;
            console.log('pageNation', this.pageNationCbi);
            console.log('lnores', this.lnoresCbi);
            console.log('pageInfo', this.pageInfoCbi.page_info);
          } else {
            this.load = false;
            this.util.showToast(this.leadnCbi.message, 'success', 'bottom');
          }
        },
        (error) => {
          this.load = false;
          console.log('error', error);
          if (error.error.error == 'invalid_token' || error.status == 401) {
            this.fungsilogout();
          } else if (
            error.error.error_description == 'The access token is missing'
          ) {
            this.util.showToast(
              error.error.error_description,
              'danger',
              'bottom'
            );
            this.fungsilogout();
          } else if (error.error.error_message) {
            this.util.showToast(error.error.error_message, 'danger', 'bottom');
          } else if (!error.error.error_message) {
            this.util.showToast(error.error.message, 'danger', 'bottom');
          } else {
            this.util.showToast(error.error.message, 'danger', 'bottom');
          }
        }
      );
  }

  getPindahKelompok() {
    this.load = true;
    let a = {
      product_name: this.nn,
    };
    let b = {
      payment_type_id: '',
    };
    const form = JSON.stringify({
      q: a,
      and: b,
      page: this.pagePindahKelompok,
    });
    this.api.post('backoffice/delegasi/pindah-kelompok-list', form)
    .subscribe(
      (data) => {
        this.pindahKelompokResponse = data;
        console.log('pindahKelompokResponse', this.pindahKelompokResponse);
        if (this.pindahKelompokResponse.error == 0) {
          this.load = false;
          this.dataPindahKelompok = this.pindahKelompokResponse.data.rows;
          this.pageInfoPindahKelompok = this.pindahKelompokResponse.data;
          console.log('dataPindahKelompok', this.dataPindahKelompok);
        } else {
          this.load = false;
          this.util.showToast(this.delegasiKelompokResponse.message, 'success', 'bottom');
        }
      },
      (error) => {
        this.load = false;
        console.log('error', error);
        this.api.errorCond(error);
      }
    );
  }


  getDelegasiKelompok() {
    this.load = true;
    let a = {
      product_name: this.nn,
    };
    let b = {
      payment_type_id: '',
    };
    const form = JSON.stringify({
      q: a,
      and: b,
      page: this.pageDelegasiKelompok,
    });
    this.api.post('backoffice/delegasi/kelompok-list', form).subscribe(
      (data) => {
        this.delegasiKelompokResponse = data;
        console.log('delegasiKelompokResponse', this.delegasiKelompokResponse);
        if (this.delegasiKelompokResponse.error == 0) {
          this.load = false;
          this.dataDelegasiKelompok = this.delegasiKelompokResponse.data.rows;
          this.pageInfoDelegasiKelompok = this.delegasiKelompokResponse.data;
          console.log('dataDelegasiKelompok', this.dataDelegasiKelompok);
        } else {
          this.load = false;
          this.util.showToast(this.delegasiKelompokResponse.message, 'success', 'bottom');
        }
      },
      (error) => {
        this.load = false;
        console.log('error', error);
        this.api.errorCond(error);
      }
    );
  }

  addx() {
    try {
      this.parent = this.users.find((item: any) => item.menu_id === 'Leads');
      this.children = this.parent.childrens.find(
        (item: any) => item.id === 'Pengajuan SLIK'
      );
      this.action = this.children.actions;
      console.log(this.users);
      console.log(this.children);
      console.log(this.action);

      this.act1 = this.action.find((item: any) => item === 'Reject Pengajuan');
      console.log(this.act1);
    } catch (error) {}
  }

  logout() {}

  fungsilogout() {
    this.util.showToast(
      'Sesi anda berakhir, Silahkan Login Kembali',
      'success',
      'bottom'
    );
    localStorage.removeItem('usertoken');
    localStorage.removeItem('user');
    this.route.navigate(['./login']);
    window.location.reload();
  }

  async reject(p: any) {
    const modal = await this.modalController.create({
      component: KonfirmasiHapusComponent,
      cssClass: 'modalConfirmation',
      componentProps: {
        image: 'assets/imgs/reject-slik.svg',
        title: 'Reject Pengajuan SLIK?',
        titlePrimaryButton: 'Reject',
        titleSecondaryButton: 'Batal',
        desc: 'Pengajuan yang telah ditolak tidak bisa dikembalikan lagi',
        button: '2',
      },
    });
    modal.onDidDismiss().then((data: any) => {
      if (data.role === 'confirm') {
        this.rejectAksi(p);
      }
    });
    return await modal.present();
  }

  rejectAksi(p: any) {
    this.token = localStorage.getItem('usertoken') || '';
    this.load = true;
    let body = {};

    let hd = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.token,
    };
    this.load = true;
    this.http
      .put(this.baseUrl + 'backoffice/leads/reject/pengajuan-slik/' + p, body, {
        headers: hd,
      })
      .subscribe(
        (data) => {
          this.add = data;
          console.log('add', this.add);
          if (this.add.error == 0) {
            this.load = false;
            // console.log('ad',this.add.message);
            this.page = 1;
            this.res();
            this.util.showToast(this.add.message, 'success', 'bottom');
          } else {
            this.load = false;
            this.util.showToast(this.add.message, 'danger', 'bottom');
          }
        },
        (error) => {
          this.load = false;
          console.log('error', error);
          if (error.error.error == 'invalid_token' || error.status == 401) {
            this.fungsilogout();
          } else {
            this.util.showToast(error.error.message, 'danger', 'bottom');
          }
        }
      );
  }

  res() {
    console.log('pageNotResponse', this.page);
    let a = {
      product_name: this.nn,
    };
    let b = {
      payment_type_id: '',
    };
    this.form = JSON.stringify({
      q: a,
      and: b,
      page: this.page,
      // limit:6
    });
    console.log('FORM', this.form);
    this.token = localStorage.getItem('usertoken') || '';
    let hd = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.token,
    };
    this.load = true;
    this.http
      .post(this.baseUrl + 'backoffice/delegasi/survey-list', this.form, {
        headers: hd,
      })
      .subscribe(
        (data) => {
          this.leadn = data;
          console.log('leadn', this.leadn);
          if (this.leadn.error == 0) {
            this.load = false;
            this.lnores = this.leadn.data.rows;
            this.pageInfo = this.leadn.data;
            console.log('pageNation', this.pageNation);
            console.log('lnores', this.lnores);
            console.log('pageInfo', this.pageInfo.page_info);
          } else {
            this.load = false;
            this.util.showToast(this.leadn.message, 'success', 'bottom');
          }
        },
        (error) => {
          this.load = false;
          console.log('error', error);
          if (error.error.error == 'invalid_token' || error.status == 401) {
            this.fungsilogout();
          } else if (
            error.error.error_description == 'The access token is missing'
          ) {
            this.util.showToast(
              error.error.error_description,
              'danger',
              'bottom'
            );
            this.fungsilogout();
          } else if (error.error.error_message) {
            this.util.showToast(error.error.error_message, 'danger', 'bottom');
          } else if (!error.error.error_message) {
            this.util.showToast(error.error.message, 'danger', 'bottom');
          } else {
            this.util.showToast(error.error.message, 'danger', 'bottom');
          }
        }
      );
  }

  firstPage() {
    this.page = 1;
    this.res();
  }

  prevPage() {
    this.page = this.page -= 1;
    this.res();
  }

  nextPage() {
    this.page = this.page + 1;
    this.res();
  }

  lastPage() {
    this.page = this.pageInfo.total_pages;
    this.res();
  }

  submitForm() {
    console.log('FORM', this.ionicForm.value);
    this.nn = this.ionicForm.value.name;
    this.isSubmitted = true;
    if (!this.ionicForm.valid) {
      console.log('Please provide all the required values!');
      return false;
    } else {
      console.log('Keyboard', this.nn);
      this.res();
    }
  }

  filt(p) {
    if (p == 'semua') {
      this.filterr = '';
    } else {
      this.filterr = '/status/' + p;
    }
    this.res();
  }

  acc(val) {
    if (this.accor == '') {
      this.accor = val;
    } else if (this.accor == val) {
      this.accor = '';
    } else {
      this.accor = val;
    }
    console.log('accor', this.accor);
  }

  search() {
    if (this.manjang == false) {
      this.manjang = true;
    } else {
      this.manjang = false;
    }
    console.log(this.manjang);
  }

  async update(p) {
    const modal = await this.modalController.create({
      component: LeadsUpdateStatusPage,
      cssClass: 'wd-req',
      componentProps: {
        id: p,
      },
    });
    modal.onDidDismiss().then((data) => {
      // this.page = 1;
      this.res();
    });
    return await modal.present();
  }

  checkMasterKelompok() {
    setTimeout(() => {
      this.lnoresCbi.forEach((obj) => {
        obj.isChecked = this.masterCheck;
      });
    });
  }

  checkEventKelompok() {
    const totalItems = this.lnoresCbi.length;
    let checked = 0;
    this.lnoresCbi.map((obj) => {
      if (obj.isChecked) checked++;
    });
    if (checked > 0 && checked < totalItems) {
      //Check Satu
      this.isIndeterminate = true;
      this.masterCheck = false;
      this.aa = this.lnoresCbi.filter((value, index) => {
        return value.isChecked;
      });
      this.opsi = true;
    } else if (checked == totalItems) {
      //Check Semua
      this.masterCheck = true;
      this.isIndeterminate = false;
      this.aa = this.lnoresCbi.filter((value, index) => {
        return value.isChecked;
      });
      this.opsi = true;
    } else {
      //Uncheck
      this.isIndeterminate = false;
      this.masterCheck = false;
      this.aa = '';
      this.opsi = false;
    }
    console.log('aa', this.aa);
    console.log('opsi', this.opsi);
    this.totalCekData = checked;
    this.resAr = { id: this.aa.map((obj) => obj.id) };
    console.log('resAr', this.resAr);

    if (this.resAr.id.length > 1) {
      this.btnDisabledKelompok = false;
    } else {
      this.btnDisabledKelompok = true;
    }
  }

  checkMaster() {
    setTimeout(() => {
      this.lnores.forEach((obj) => {
        obj.isChecked = this.masterCheck;
      });
    });
  }

  checkEvent() {
    const totalItems = this.lnores.length;
    let checked = 0;
    this.lnores.map((obj) => {
      if (obj.isChecked) checked++;
    });
    if (checked > 0 && checked < totalItems) {
      //Check Satu
      this.isIndeterminate = true;
      this.masterCheck = false;
      this.aa = this.lnores.filter((value, index) => {
        return value.isChecked;
      });
      this.opsi = true;
    } else if (checked == totalItems) {
      //Check Semua
      this.masterCheck = true;
      this.isIndeterminate = false;
      this.aa = this.lnores.filter((value, index) => {
        return value.isChecked;
      });
      this.opsi = true;
    } else {
      //Uncheck
      this.isIndeterminate = false;
      this.masterCheck = false;
      this.aa = '';
      this.opsi = false;
    }
    console.log('aa', this.aa);
    console.log('opsi', this.opsi);
    this.totalCekData = checked;
    this.resAr = { id: this.aa.map((obj) => obj.lead_id) };
    console.log('resAr', this.resAr);

    if (this.resAr.id.length > 1) {
      this.btnDisabled = false;
    } else {
      this.btnDisabled = true;
    }
  }

  openOpsi() {
    if (this.opsi == false) {
      this.opsi = true;
    } else {
      this.opsi = false;
    }
    console.log(this.opsi);
  }

  dismiss() {
    this.opsi = false;
  }

  det(p) {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        no: p,
        flg: '1',
        fromPage: 'pengajuan-slik',
      },
    };
    this.route.navigate(['./leads-detail'], navigationExtras);
  }

  detX(p, flg) {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        no: p,
        flg: '2',
        fromPage: 'pengajuan-slik',
      },
    };
    this.route.navigate(['./leads-detail'], navigationExtras);
  }

  ajukan() {
    this.token = localStorage.getItem('usertoken') || '';
    let hd = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.token,
    };
    this.load = true;
    this.http
      .post(
        this.baseUrl + 'backoffice/sales/leads/pengajuan/slik',
        this.resAr,
        { headers: hd }
      )
      .subscribe(
        (data) => {
          this.add = data;
          console.log('add', this.add);
          if (this.add.error == 0) {
            this.load = false;
            console.log('ad', this.add.message);
          } else {
            this.load = false;
            this.util.showToast(this.add.message, 'danger', 'bottom');
          }
        },
        (error) => {
          this.load = false;
          console.log('error', error);
          if (error.error.error == 'invalid_token' || error.status == 401) {
            this.fungsilogout();
          } else {
            this.util.showToast(error.error.message, 'danger', 'bottom');
          }
        }
      );
  }

  submit() {}

  async notif(ev: any) {
    const popover = await this.popoverController.create({
      component: NotificationPage,
      cssClass: 'notif-css',
      backdropDismiss: true,
      event: ev,
      translucent: true,
      showBackdrop: false,
    });
    await popover.present();

    const { role } = await popover.onDidDismiss();
    console.log('onDidDismiss resolved with role', role);
  }
}
